import React from "react";
import { StompSessionProvider } from "react-stomp-hooks";
import { SubscriptionsHook } from "./SubscriptionsHooks";
import { SubscriptionInfos } from "./SubscriptionSocket";

export type StompFilter = {
  field: string;
  operator: string;
  value: string;
};

interface Props {
  webSocketUrl: string;
  authToken: string;
  children: React.ReactElement[];
  subscriptions: SubscriptionInfos[];
  handleApplicatEvent: (event: any) => void;
}

function StompComponent({
  webSocketUrl,
  authToken,
  children,
  subscriptions,
  handleApplicatEvent
}: Props) {

  return (
    <StompSessionProvider url={webSocketUrl}>
      <>
        <SubscriptionsHook
          handleApplicatEvent={handleApplicatEvent}
          authToken={authToken}
          subscriptions={subscriptions}
          >
            <></>
        </SubscriptionsHook>
        {children}
      </>
    </StompSessionProvider>
  );
}

export default React.memo(StompComponent);
